import { render, staticRenderFns } from "./uusi-yek-tyoskentelyjakso.vue?vue&type=template&id=7d342032&scoped=true&"
import script from "./uusi-yek-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
export * from "./uusi-yek-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-yek-tyoskentelyjakso.vue?vue&type=style&index=0&id=7d342032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d342032",
  null
  
)

export default component.exports